import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import type { AnalysisFreshness } from "./TeamDashboard";

// Через сколько после конца матча запустили разбор — корзины бэкенда по порядку.
export const FRESHNESS_LABELS: Record<AnalysisFreshness, MessageDescriptor> = {
  under_15m: msg`under 15 minutes`,
  under_1h: msg`15 minutes – 1 hour`,
  under_6h: msg`1–6 hours`,
  under_24h: msg`6–24 hours`,
  later: msg`over a day`,
};
